import React from 'react';
import PropTypes from 'prop-types';
import { motion, AnimatePresence } from 'framer-motion';
import Select from 'react-select';
import Label from '../Label/Label';
import Input, { INPUT_TYPES } from '../Input/Input';
import Button from '../Button/Button';

const Roles = props => {
  return (
    <span className="relative">
      <Button className="h-8" onClick={props.toggleAddNewRolePopup}>
        Roles
      </Button>
      <AnimatePresence>
        {props.showAddRolePopup && (
          <motion.div
            initial={{ opacity: 0, y: '90%', bottom: '-5px' }}
            animate={{ opacity: 1, y: '100%' }}
            exit={{ opacity: 0, y: '90%' }}
            transition={{
              ease: [0.18, 0.89, 0.39, 1.4],
              duration: 0.4,
            }}
            className="button-popup absolute pin-r p-4 bg-white shadow-md rounded z-10 flex">
            <div className="w-64 mr-4">
              <Input
                id="newRoleName"
                name="newRoleName"
                type={INPUT_TYPES.TEXT}
                label="Name"
                placeholder="Enter role name"
                value={props.newRoleName}
                onChange={event =>
                  props.onChange('newRoleName', event.target.value)
                }
                inputClassName="shadow-inner bg-almostWhite"
              />
              <div className="mt-4">
                <Label text="Select permissions" />
                <Select
                  isMulti
                  isClearable
                  isSearchable
                  options={props.availalbePermissions}
                  classNamePrefix="formatted_react_select"
                  className="mt-2"
                  value={props.getMultiSelectValue(
                    props.availalbePermissions,
                    props.newRolePermissions
                  )}
                  onChange={valueArray =>
                    props.onChange(
                      'newRolePermissions',
                      valueArray ? valueArray.map(obj => obj.value) : []
                    )
                  }
                />
              </div>
              <Button
                type="green"
                className="h-8 mt-6"
                onClick={props.submitRole}>
                Create new Role
              </Button>
            </div>
            <div className="w-64 ml-4 text-left">
              <div className="text-sm mb-2">Available Roles</div>
              <table className="block text-xs border-collapse border-hidden overflow-y-scroll max-h-xxs">
                <thead>
                  <tr>
                    <th className="p-2 b-1-midGrey font-medium">Role</th>
                    <th className="p-2 b-1-midGrey font-medium">Permissions</th>
                  </tr>
                </thead>
                <tbody>
                  {props.availableRoles.map(role => {
                    return (
                      <tr key={role.id}>
                        <td className="p-2 align-top b-1-midGrey">
                          {role.name}
                        </td>
                        <td className="p-2 align-top b-1-midGrey tracking-wide">
                          {role.account_permissions.map(p => p.name).join(', ')}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </span>
  );
};

Roles.propTypes = {
  toggleAddNewRolePopup: PropTypes.func.isRequired,
  showAddRolePopup: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  getMultiSelectValue: PropTypes.func.isRequired,
  submitRole: PropTypes.func.isRequired,
  availalbePermissions: PropTypes.array.isRequired,
  availableRoles: PropTypes.array.isRequired,
  newRolePermissions: PropTypes.array.isRequired,
  newRoleName: PropTypes.string.isRequired,
};

export default  Roles;
